module.exports = __webpack_public_path__ + "img/uz.2c99360b.svg";